import { StorageService } from '../../service/storage/storage.service'; // Storage Service
import { Injectable, EventEmitter, Output } from '@angular/core';

export async function getAllContract(requestService,refresh = true){ 
  const stoage = new StorageService();
  let AllContractReturn = await stoage.getStorage('AllContract');
  if(refresh){
    let parentApi =  requestService.getParentAPI();
    const getAllContractRoute = parentApi.route.getAllContract;
    const AllContract = await parentApi.get(getAllContractRoute,'', parentApi.requestSecret());
    AllContractReturn = JSON.stringify(AllContract['result']);
    await stoage.setStorage("AllContract", AllContractReturn);
    return AllContractReturn;
  }
  AllContractReturn = await stoage.getStorage('AllContract');
  return AllContractReturn;
}

@Injectable({
    providedIn: 'root'
})
export class TermSelectContainer {
  @Output() changeTermActive = new EventEmitter();
  @Output() checkAnotherPage = new EventEmitter();
  @Output() setTermNameColor = new EventEmitter();

  // make for change term after first time
 async changeActive(contractID, open_booking, term_name, term_colour, checkAnother = false) {

    const storage = new StorageService();
    const term_old = await storage.getStorage('term_active');
    const term_active_obj = {
      contract_id: contractID,
      open_booking: open_booking,
      term_name: term_name,
      term_colour: term_colour,
    }

    if (checkAnother) {
      term_active_obj['change'] = false;
      return this.changeTermActive.emit(term_active_obj);
    }

    await storage.setStorage("term_active", JSON.stringify(term_active_obj));
    await storage.setStorage("term_old", JSON.stringify(JSON.parse(term_old)));
    //await stoage.removeStorage("term_active");
    this.changeTermActive.emit(term_active_obj);
  }

  // check another page will show alert if change term click continue
  checkAnotherPageFunc(checkAnother = false){
    this.checkAnotherPage.emit(checkAnother);
  }

  // set term active to term old
  async setTermOld(){
    const storage = new StorageService();
    const term_old_data = await storage.getStorage('term_old');
    const term_old = JSON.parse(term_old_data);
    await storage.setStorage("term_active", JSON.stringify(term_old));
    return term_old;
  }

  async setTermNameActive(contractId){
    const storage = new StorageService();
    let Allcontract = JSON.parse(storage.getStorage("AllContract"));
    const TermOld = Allcontract.filter((item) => item.contractID === contractId);
    const term_active_obj = {
      contract_id: TermOld[0].contractID,
      open_booking: TermOld[0].open_booking,
      term_name: TermOld[0].term_name,
      term_colour: TermOld[0].term_colour,
    }
    await storage.setStorage("term_active", JSON.stringify(term_active_obj));
    this.setTermNameColor.emit(TermOld[0]);
  }

  // function creat by Chat GPT convert hex to HSL for change background color and  foreground color
  hexToHSL(hex) {
    // Remove the '#' symbol from the beginning (if present)
    hex = hex.replace('#', '');
  
    // Convert the hexadecimal values to decimal
    var r = parseInt(hex.substring(0, 2), 16) / 255;
    var g = parseInt(hex.substring(2, 4), 16) / 255;
    var b = parseInt(hex.substring(4, 6), 16) / 255;
  
    // Find the minimum and maximum values of R, G, B
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
  
    // Calculate the lightness
    var lightness = (max + min) / 2;
    
    return lightness
  }

  btnTermHover(i,ishover,color,page){
    const btn_term_hover =  document.getElementById('btn-hover-term-'+page+i); // get element button in show all term
    // const tooltiptext =  document.getElementById('tooltiptext'+page+i); 
    // const triangle =  document.getElementById('triangle'+page+i);
   if(color != ''){
    const hsl_LColor = this.hexToHSL(color);
    const colorText = hsl_LColor > 0.5 ? '#000' : '#fff';
    if(ishover){
      btn_term_hover.style.background = color;
      btn_term_hover.style.color = colorText;
      // if(tooltiptext != null){
      //   tooltiptext.style.background = color;
      //   tooltiptext.style.color = colorText;
      //   triangle.style.borderBottom =' 10px solid '+color;
      // }
    }else{
      btn_term_hover.style.background = '#fff';
      btn_term_hover.style.color = color;
    }
   }else{
    if(ishover){
      btn_term_hover.style.background = '#000';
      btn_term_hover.style.color = '#fff';
    }else{
      btn_term_hover.style.background = '#fff';
      btn_term_hover.style.color = '#000';
    }
   }
  }
}